export enum TransactionDirection {
    INCOMING = "INCOMING",
    OUTGOING = "OUTGOING"
}